const ManageNotifications = () => {
  return <div>Notifications</div>;
};

export default ManageNotifications;
